import { IoIosArrowBack } from "react-icons/io";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AnimatedWrapper from "../components/AnimatedWrapper";
import ProgressBar from "../components/ProgressBar";
import { skincareProductsUse } from "../config/data";
import { useUser } from "../context/useInfo";
import amplitude from "../utils/amplitude";

export default function Page8() {
  const navigate = useNavigate();
  const [selectedOptions, setSelectedOptions] = useState([]);
  const { updateUserData } = useUser();

  // Устанавливаем --vh для корректной высоты экрана на мобильных
  useEffect(() => {
    const setVH = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    };
    if (process.env.NODE_ENV === "production") {
      amplitude.track("Quiz Step Open", {
        step_number: 8,
      });
    }
    setVH();
    window.addEventListener("resize", setVH);
    return () => window.removeEventListener("resize", setVH);
  }, []);

  const nextStep = () => {
    updateUserData({ skincareProductsUse: selectedOptions });
    if (process.env.NODE_ENV === "production") {
      amplitude.track("Quiz Step Complete", {
        step_number: 8,
        answers: { skincareProductsUse: selectedOptions },
      });
    }
    navigate("/quiz9");
  };

  const stepBack = () => {
    updateUserData({ skincareProductsUse: "" });
    navigate("/quiz7");
  };

  const toggleOption = (option) => {
    setSelectedOptions((prev) =>
      prev.includes(option)
        ? prev.filter((item) => item !== option)
        : [...prev, option]
    );
  };

  const valid = selectedOptions.length > 0 ? true : false;

  return (
    <AnimatedWrapper>
      <div
        className="flex flex-col max-w-md px-4"
        style={{ height: "calc(var(--vh, 1vh) * 100)" }}
      >
        {/* Top bar */}
        <div className="sticky top-0 z-10 bg-white pt-2 pb-3">
          <div className="flex items-center space-x-2">
            <button className="text-gray-600" onClick={stepBack}>
              <IoIosArrowBack size={24} />
            </button>
            <ProgressBar />
          </div>
          <h1 className="text-center text-base sm:text-lg font-semibold mt-2">
            Which skincare products do you use?
          </h1>
        </div>

        {/* Список опций — занимает всё доступное пространство, скролл */}
        <div className="flex-1 overflow-y-auto space-y-2 py-4 scrollbar-hide">
          {skincareProductsUse.map((option) => (
            <div
              key={option}
              className="flex items-center justify-between w-full py-[10px] px-4 bg-gray-50 rounded-xl border text-sm hover:bg-gray-100 transition cursor-pointer"
              onClick={() => toggleOption(option)}
            >
              <span className="text-left">{option}</span>
              <div
                className={`w-5 h-5 rounded-full border-2 flex items-center justify-center 
                  ${
                    selectedOptions.includes(option)
                      ? "border-pink-500 bg-pink-500"
                      : "border-gray-300"
                  }`}
              >
                {selectedOptions.includes(option) && (
                  <svg
                    className="w-3 h-3 text-white"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Кнопка всегда внизу */}
        <div
          className={`sticky bottom-2 z-10 bg-white pt-2 mb-2 transition-opacity duration-300`}
        >
          <button
            disabled={!valid}
            className={`w-full py-4 rounded-full text-white font-semibold transition-colors duration-300 ${
              valid
                ? "bg-pinkCustom text-white hover:bg-pink-600"
                : "bg-gray-300 text-gray-500 cursor-not-allowed"
            }`}
            onClick={nextStep}
          >
            Next
          </button>
        </div>
      </div>
    </AnimatedWrapper>
  );
}
